import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaPlug } from 'react-icons/fa';
import ConnectClaudeAdminModal from './ConnectClaudeAdminModal';
import Tooltip from '../../components/Tooltip';
import { clearAllDrafts } from '../../utils/tmeWikiDrafts';

const AdminLayout = ({ children }) => {
    const navigate = useNavigate();
    const [showConnectClaude, setShowConnectClaude] = useState(false);
    const location = useLocation();
    const currentPath = location.pathname;

    const handleLogout = () => {
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminRefreshToken');
        localStorage.removeItem('adminEmail');
        // ⚠️ TME Wiki drafts are INTERNAL PROCEDURE TEXT in unencrypted browser
        // storage (§10.4). Leaving them behind on a shared machine is the whole
        // reason their key carries the admin's Cognito `sub` - and the token
        // being gone is exactly the moment they stop being anybody's.
        clearAllDrafts();
        navigate('/admin/login');
    };

    return (
        <div className="h-screen bg-gray-50 flex flex-col overflow-hidden">
            <div className="bg-white shadow sticky top-0 z-10">
                <div className="px-4">
                    <div className="flex items-center border-b border-gray-200">
                        <h1 className="text-xl font-bold text-primary-900 py-3">
                            Admin <span className="text-red-900">Portal</span>
                        </h1>
                        <div className="h-8 w-px bg-gray-300 mx-6"></div>
                        <div className="flex gap-4 self-end">
                            <button
                                onClick={() => navigate('/admin/dashboard')}
                                className={`pb-3 px-1 border-b-2 ${
                                    currentPath === '/admin/dashboard' || currentPath === '/admin' || currentPath.startsWith('/admin/client-view')
                                        ? 'text-primary-700 border-primary-700 font-medium'
                                        : 'text-gray-600 hover:text-primary-700 border-transparent'
                                }`}
                            >
                                Client Leads
                            </button>
                            <button
                                onClick={() => navigate('/admin/clients')}
                                className={`pb-3 px-1 border-b-2 ${
                                    currentPath.startsWith('/admin/clients')
                                        ? 'text-primary-700 border-primary-700 font-medium'
                                        : 'text-gray-600 hover:text-primary-700 border-transparent'
                                }`}
                            >
                                Client Management
                            </button>
                            <button
                                onClick={() => navigate('/admin/templates')}
                                className={`pb-3 px-1 border-b-2 ${
                                    currentPath.startsWith('/admin/templates')
                                        ? 'text-primary-700 border-primary-700 font-medium'
                                        : 'text-gray-600 hover:text-primary-700 border-transparent'
                                }`}
                            >
                                Templates
                            </button>
                            <button
                                onClick={() => navigate('/admin/scripts')}
                                className={`pb-3 px-1 border-b-2 ${
                                    currentPath.startsWith('/admin/scripts')
                                        ? 'text-primary-700 border-primary-700 font-medium'
                                        : 'text-gray-600 hover:text-primary-700 border-transparent'
                                }`}
                            >
                                Script Repository
                            </button>
                            {/* Renamed from "Wiki Editor" (D11) now that a
                                SECOND wiki exists. The route is unchanged - the
                                label alone moved. */}
                            <button
                                onClick={() => navigate('/admin/wiki-editor')}
                                className={`pb-3 px-1 border-b-2 ${
                                    currentPath.startsWith('/admin/wiki-editor')
                                        ? 'text-primary-700 border-primary-700 font-medium'
                                        : 'text-gray-600 hover:text-primary-700 border-transparent'
                                }`}
                            >
                                Client Wiki
                            </button>
                            <button
                                onClick={() => navigate('/admin/tme-wiki')}
                                className={`pb-3 px-1 border-b-2 ${
                                    currentPath.startsWith('/admin/tme-wiki')
                                        ? 'text-primary-700 border-primary-700 font-medium'
                                        : 'text-gray-600 hover:text-primary-700 border-transparent'
                                }`}
                            >
                                TME Wiki
                            </button>
                            <button
                                onClick={() => navigate('/admin/audit')}
                                className={`pb-3 px-1 border-b-2 ${
                                    currentPath.startsWith('/admin/audit')
                                        ? 'text-primary-700 border-primary-700 font-medium'
                                        : 'text-gray-600 hover:text-primary-700 border-transparent'
                                }`}
                            >
                                Audit Trail
                            </button>
                        </div>

                        <div className="flex items-center gap-4 ml-auto">
                            {/* Today's date - the portal never showed it anywhere
                                (Bill, 2026-07-31) */}
                            <span className="text-sm text-gray-500 whitespace-nowrap">
                                {new Date().toLocaleDateString('en-GB', {
                                    weekday: 'short', day: 'numeric', month: 'short', year: 'numeric'
                                })}
                            </span>
                            <span className="text-sm text-gray-600">
                                {localStorage.getItem('adminEmail') || ''}
                            </span>
                            <Tooltip text="Connect Claude to this portal">
                                <button
                                    onClick={() => setShowConnectClaude(true)}
                                    className="text-sm px-4 py-2 bg-gray-100 text-gray-600 border border-gray-300 rounded hover:bg-gray-200 flex items-center gap-2"
                                >
                                    <FaPlug size={14} />
                                    Claude
                                </button>
                            </Tooltip>
                            <button
                                onClick={handleLogout}
                                className="btn-primary text-sm px-4 py-2"
                            >
                                Logout
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex-1 overflow-hidden">
                {children}
            </div>

            <ConnectClaudeAdminModal
                isOpen={showConnectClaude}
                onClose={() => setShowConnectClaude(false)}
                apiUrl={process.env.REACT_APP_API_URL}
            />
        </div>
    );
};

export default AdminLayout;
